import { DealStatus, HasDeal, SortByOption } from '@business/entities/deal';
import { CommonService } from '../common_service';

export function getStatusTitle(status: DealStatus) {
  switch (status) {
    case DealStatus.inProgress:
      return 'In Progress';
    case DealStatus.won:
      return 'Won';
    case DealStatus.lost:
      return 'Lost';
    case DealStatus.deleted:
      return 'Deleted';
    case DealStatus.reopen:
      return 'Reopen';
  }
  return 'Unknown';
}

export function getStatusEmoji(status: DealStatus) {
  switch (status) {
    case DealStatus.inProgress:
      return 'meh';
    case DealStatus.won:
      return 'smile';
    case DealStatus.lost:
      return 'frown';
    case DealStatus.deleted:
      return 'frown';
  }
  return 'Unknown';
}

export function getStatusColor(status: DealStatus) {
  switch (status) {
    case DealStatus.inProgress:
      return 'text-dark';
    case DealStatus.won:
      return 'text-success';
    case DealStatus.lost:
      return 'text-danger';
    case DealStatus.deleted:
      return 'text-danger';
  }
  return 'Unknown';
}

export function allStatuses() {
  return [DealStatus.inProgress, DealStatus.won, DealStatus.lost, DealStatus.deleted];
}

export function allSortByOptions(isGCInternalSchedularEnabled) {
  const options = [
    SortByOption.default,
    SortByOption.created_date_new_to_old,
    SortByOption.created_date_old_to_new,
    SortByOption.last_activity_new_to_old,
    SortByOption.last_activity_old_to_new,
  ];

  if (!isGCInternalSchedularEnabled) {
    return options;
  }

  options.push(SortByOption.event_new_to_old);
  options.push(SortByOption.event_old_to_new);

  return options;
}

export function getHasDealTitle(hasDeal: HasDeal) {
  switch (hasDeal) {
    case HasDeal.all:
      return 'All';
    case HasDeal.yes:
      return 'Has Deal';
    case HasDeal.no:
      return 'No Deal';
  }
}

export function getDealSortByOptionTitle(option: SortByOption) {
  switch (option) {
    case SortByOption.default:
      return 'Sort By: Default';
    case SortByOption.created_date_new_to_old:
      return 'Sort By: Created Date: New to Old';
    case SortByOption.created_date_old_to_new:
      return 'Sort By: Created Date: Old to New';
    case SortByOption.last_activity_new_to_old:
      return 'Sort By: Last Activity: Old to New';
    case SortByOption.last_activity_old_to_new:
      return 'Sort By: Last Activity: New to Old';
    case SortByOption.event_new_to_old:
      return 'Sort By: Event Date: New to Old';
    case SortByOption.event_old_to_new:
      return 'Sort By: Event Date: Old to New';
  }
}
